import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { BirthCertificateController } from 'src/controllers/birth-certificate.controller'
import { BirthCertificateDto } from 'src/dto/birth-certificate.dto'
import { BirthCertificateDtoParams } from 'src/services/api/birth-certificate.service'

const birthCertificateController = new BirthCertificateController()

export function useGetBirthCertificateList(params: BirthCertificateDtoParams = {}) {
  const { userFarm: farmId } = useAuth()

  return useQuery<BirthCertificateDto[], Error>({
    queryKey: ['getBirthCertificateList', farmId, params],
    queryFn: () => birthCertificateController.getBirthCertificateList(farmId!, params),
    enabled: !!farmId
  })
}
